var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 12.9994C7.67883 13 7.59898 13 7.50777 13H3.39768C2.55925 13 2.1394 13 1.81885 12.8367C1.5366 12.6929 1.3073 12.4632 1.16349 12.1809C1 11.86 1 11.4402 1 10.6001V3.40015C1 2.56007 1 2.13972 1.16349 1.81885C1.3073 1.5366 1.5366 1.3073 1.81885 1.16349C2.13972 1 2.56007 1 3.40015 1H10.6001C11.4402 1 11.8597 1 12.1805 1.16349C12.4628 1.3073 12.6929 1.5366 12.8367 1.81885C13 2.1394 13 2.55925 13 3.39768V7.50603C13 7.59798 13 7.6784 12.9993 7.75M7.75 12.9994C7.96424 12.9974 8.09975 12.9897 8.22913 12.9586C8.38219 12.9219 8.52839 12.861 8.6626 12.7788C8.81397 12.686 8.9437 12.5567 9.20312 12.2972L12.2972 9.20312C12.5567 8.9437 12.6857 8.81397 12.7784 8.6626C12.8607 8.52839 12.9215 8.38182 12.9583 8.22877C12.9893 8.0994 12.9973 7.96409 12.9993 7.75M7.75 12.9994V8.95007C7.75 8.53003 7.75 8.31986 7.83175 8.15942C7.90365 8.0183 8.0183 7.90365 8.15942 7.83175C8.31986 7.75 8.52967 7.75 8.94971 7.75H12.9993",
    stroke: "#646A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotes);
export default __webpack_public_path__ + "static/media/EmptyNotes.937bc12986cae3a9db4fd794706c15e5.svg";
export { ForwardRef as ReactComponent };